module.exports = __webpack_public_path__ + "static/media/background.a88f8e9e.webp";